export const HELP_EVENT = 'bp:open-help'

export const openHelp = () => window.dispatchEvent(new CustomEvent(HELP_EVENT))
